import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'page-header-without-filter',
  templateUrl: './page-header-without-filter.component.html',
  styleUrls: ['./page-header-without-filter.component.scss']
})
export class PageHeaderWithoutFilterComponent implements OnInit {
  @Output() actionEvent:EventEmitter<any> = new EventEmitter<any>();
  @Input() cardCategory: string;
  @Input() cardTitle: string;
  @Input() actionTitle: string;
  @Input() withAction: boolean = true;


  constructor() { }

  ngOnInit() {
  }

  action() {
    this.actionEvent.emit();
  }
}
